module.exports = __webpack_public_path__ + "img/3.01901630.jpg";